<template lang="pug">
  card-back(@click="click")
    span {{ year }}
</template>

<script>
import CardBack from './CardBack'

export default {
  name: 'EventCardBack',
  components: {
    CardBack
  },
  props: {
    event: Object
  },
  computed: {
    year() {
      return this.event.year;
    }
  },
  methods: {
    click() {
      this.$emit('click');
    }
  }
}
</script>

<style scoped lang="stylus">
  span
    font-font-weight 900
    font-size 28px
</style>
